import { createRouter, createWebHistory } from 'vue-router'

import store from '../store'

import LoginView from '../views/LoginView.vue'
import LogoutView from '../views/LogoutView.vue'
import JobsView from '../views/JobsView.vue'
import JobView from '../views/JobView.vue'
import JobPrintView from '../views/JobPrintView.vue'

import MyAccountView from '../views/MyAccountView.vue'
import AdminView from '../views/AdminView.vue'
import UsersView from '../views/UsersView.vue'
import UserAddView from '../views/UserAddView.vue'
import UserEditView from '../views/UserEditView.vue'
import DiskUsageView from '../views/DiskUsageView.vue'

const routes = [
  {
    path: '/',
    redirect: {
      name: 'Jobs'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/logout',
    name: 'Logout',
    component: LogoutView,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: JobsView,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/job/:id',
    name: 'Job',
    component: JobView,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/job/:id/print',
    name: 'JobPrint',
    component: JobPrintView,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/my-account',
    name: 'MyAccount',
    component: MyAccountView,
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminView,
    meta: {
      requireAdmin: true
    }
  },
  {
    path: '/users',
    name: 'Users',
    component: UsersView,
    meta: {
      requireAdmin: true
    }
  },
  {
    path: '/users/add',
    name: 'UserAdd',
    component: UserAddView,
    meta: {
      requireAdmin: true
    }
  },
  {
    path: '/users/:user_id/edit',
    name: 'UserEdit',
    component: UserEditView,
    meta: {
      requireAdmin: true
    }
  },
  {
    path: '/admin/disk-usage',
    name: 'DiskUsage',
    component: DiskUsageView,
    meta: {
      requireAdmin: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAdmin && !store.getters.isAdmin) {
    return next('/')
  }
  if (to.matched.some(record => record.meta.requireLogin) && !store.state.isAuthenticated) {
    next({ name: 'Login' });
  }
  next()
})

export default router
